import { Label } from "../../atoms/RTCC/label";
import './../../../resources/RTCC/css/reservation/reservation.css';


export const ModalOptionForm = (props) => {
    const { title, onClick, text, id } = props;

    return (
        <div className={props.confirmText == null ? props.wrapClassName : "confirmLabelTextWrap flightInput"}>
            <Label className={props.labelClassName} label={title} />
            {props.confirmText == null ?
                <div className={props.className} onClick={onClick} id={id} tabIndex={props.tabIndex}>
                    {text}
                </div>
                :
                <Label label={props.confirmText} className="confirmLabelText" />
            }
        </div>
    );
};